import EmailOrPhoneInput from './EmailOrPhoneInput';
export * from './EmailOrPhoneInput';
export default EmailOrPhoneInput;
